import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  optionalText: PropTypes.node
};
function CheckboxGroup(_ref) {
  var children = _ref.children,
    _ref$optionalText = _ref.optionalText,
    optionalText = _ref$optionalText === void 0 ? '' : _ref$optionalText,
    title = _ref.title;
  return /*#__PURE__*/React__default.createElement("fieldset", {
    className: "checkbox-group"
  }, /*#__PURE__*/React__default.createElement("legend", null, /*#__PURE__*/React__default.createElement("span", {
    className: "h4"
  }, title), "\xA0", optionalText), children);
}
CheckboxGroup.propTypes = propTypes;

export { CheckboxGroup as default };
//# sourceMappingURL=CheckboxGroup.js.map
